import { useQueryClient } from "@tanstack/react-query";
import { matchesApi } from "@/api/matches";
import { penaltyApi } from "@/api/penalty";
import { useScope } from "./useScope";

/** Meccs-tippeléshez tartozó műveletek — sikeres mentés után frissítik a cache-t. */
export function useMatchActions() {
  const scope = useScope();
  const qc = useQueryClient();

  const invalidate = () => {
    qc.invalidateQueries({ queryKey: ["matches", scope.leagueId, scope.tournamentId] });
    qc.invalidateQueries({ queryKey: ["leaderboard", scope.leagueId, scope.tournamentId] });
  };

  return {
    submitTip: async (matchId: string, scoreA: number, scoreB: number) => {
      await matchesApi.submitTip({ ...scope, matchId, scoreA, scoreB });
      invalidate();
    },
    toggleTuti: async (matchId: string) => {
      await matchesApi.toggleTuti({ ...scope, matchId });
      invalidate();
    },
    submitPenalty: async (matchId: string, winnerTeamId: string) => {
      await penaltyApi.submit({ ...scope, matchId, winnerTeamId });
      qc.invalidateQueries({ queryKey: ["penalty", scope.leagueId, scope.tournamentId] });
    },
  };
}
